<template>
  <footer class="footer psifooter" v-if="!isMSIUser" role="contentinfo">
    <div class="container" v-if="!userDetails.isBrokerUser && !isRedirectedBrokerUrl">
      <b-row>
        <b-col sm="12" md="6" lg="6" xl="6">
            <div class="psifooterlogo">
                 <img width="200" height="100%" src="@/assets/img/psi_logo.svg" alt="PortfolioSmith">
            </div>
             <div class="psiotherproducts">
            <h2>Other Products</h2>
            <ul class="pl-0">
              <li>
                <a href="https://marketsmithindia.com/mstool/?utm_source=PortfolioSmith_Website_MSI_Button&utm_medium=PortfolioSmith_Website_MSI_Button&utm_campaign=PortfolioSmith_Website_MSI_Button" target="_blank">
                  <img
                    src="@/assets/img/MarketSmithIndiaonscroll-logo.svg"
                    class="marketsmithLogo "
                    alt="MarketSmith India"
                  >
                </a>
              </li>
              <li>
                <a href="https://tradersmith.in/?utm_source=PortfolioSmith_Website_SWTI_Button&utm_medium=PortfolioSmith_Website_SWTI_Button&utm_campaign=PortfolioSmith_Website_SWTI_Button" target="_blank">                  <img src="https://storage.googleapis.com/swtweb/Images/TraderSmith-Logo%20Inline.svg" class="traderSmith" alt="TraderSmith">
                </a>
              </li>

               <li>
                <a href="https://quantsmith.in/" target="_blank">
                  <img src="https://storage.googleapis.com/mscharts/Design2024/Quantsmith/QuantSmithLogoformalyASI.svg" class="asi" alt="QuantSmith">
                </a>
              </li>
            </ul>
          </div>
          <div class="psiwilliamoneilcompany">
          <a href="https://williamoneilindia.com/" target="_blank" rel="noopener noreferrer">
  <img
    src="@/assets/img/williamoneillogo.png"
    alt="William O'Neil India"
  >
</a>
           <p>Research Analyst</p>
           <p>SEBI Regn. Nos: INH000015543</p>
           <p>valid till 18 Mar 2029.</p>
           <a href="https://www.youtube.com/watch?v=uun2mC6eqtE" target="_blank"><p>Protect Your Finances From Cyber Threats</p></a>
          </div>

        </b-col>
        <b-col  sm="12" md="6" lg="6" xl="6">
            <b-row>
                <b-col sm="12" md="12" lg="4" xl="4">
                    <div class="psifooternavilist">
                        <h2>Site Map</h2>
                        <ul>
                            <li><router-link :to="{ name: 'home' }">Home</router-link></li>
                            <li><a href="#" @click.prevent="goToHomeSection('#features')">Features</a></li>
                            <li><a href="#" @click.prevent="goToHomeSection('#pricing')">Pricing</a></li>
                            <li><a href="#" @click.prevent="goToHomeSection('#partnerwithus')">Partner with Us</a></li>
                            <li><router-link :to="{ name: 'about' }">History</router-link></li>
                            <li><router-link :to="{ name: 'faqs' }">FAQ's</router-link></li>
                            <li><router-link :to="{ name: 'contactus' }">Contact</router-link></li>
                            <li><router-link :to="{ name: 'legalagreement' }">Legal Agreement</router-link></li>
                            <li><router-link :to="{ name: 'privacypolicy' }">Privacy Policy</router-link></li>
                            <li v-if="!isLoggedin && !isRedirectedBrokerUrl"><router-link :to="{ name: 'login', params: { id: 'login' } }">Login</router-link></li>
                            <li v-if="!isLoggedin && !isRedirectedBrokerUrl"><router-link :to="{ name: 'login', params: { id: 'signup' } }">Sign Up</router-link></li>
                            <li v-if="isLoggedin"><router-link :to="{ name: 'dashboard' }">Dashboard</router-link></li>
                            <li v-if="isLoggedin"><router-link :to="{ name: 'evaluation' }">Evaluate Portfolio</router-link></li>
                            <li v-if="isLoggedin"><router-link :to="{ name: 'reports' }">Reports</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">All pages (Sitemap)</router-link></li>
                        </ul>
                    </div>
                </b-col>
                <b-col  sm="12" md="12" lg="4" xl="4">
                 <div class="psifooternavilist">
                        <h2>Contact</h2>
                        <ul>
                            <li>080-4680 2222</li>

                        </ul>
                    </div>
                </b-col>
                <b-col sm="12" md="12" lg="4" xl="4">
                  <!-- Enable below two lines for playstore and appstore features when required -->
<!--                    <div class="psiappdownload">-->
<!--                        <a href=""><img src="@/assets/img/playstore.png"></a>-->
<!--                        <a href=""><img src="@/assets/img/appstore.png"></a>-->
<!--                    </div>-->
                    <div class="psisociallinks">
                         <ul class="list-inline mt-3">

                <li class="list-inline-item mr-4">
                  <a href="https://www.facebook.com/MSIndiaOfficial/" target="_blank" aria-label="Facebook">
                    <i class="fa fa-facebook" aria-hidden="true"></i>
                  </a>
                </li>
                <li class="list-inline-item mr-3">
                  <a href="https://www.linkedin.com/company/marketsmith-india/" target="_blank" aria-label="LinkedIn">
                    <i class="fa fa-linkedin" aria-hidden="true"></i>
                  </a>
                </li>

                <li class="list-inline-item mr-3">
                  <a href="https://twitter.com/marketsmithind" target="_blank" aria-label="Twitter">
                    <i class="fa fa-twitter" aria-hidden="true"></i>
                  </a>
                </li>
                <li class="list-inline-item mr-3">
                  <a href="https://www.youtube.com/channel/UCdR0Xje6vndwPn5PO9xKplg" target="_blank" aria-label="YouTube">
                    <i class="fa fa-youtube" aria-hidden="true" ></i>
                  </a>
                </li>
              </ul>

                    </div>
                </b-col>
            </b-row>
        </b-col>

          </b-row>


        </b-col>
      </b-row>


    </div>
    <div class="psicopyrighttext">
     <b-container>
        &#169; 2017 William O&#39;Neil India Private Limited. All Rights Reserved.
         </b-container>
        </div>
  </footer>
</template>
<script>
import { goToHomeSection } from '@/utils/homeSectionNav'

export default {
  methods: {
    goToHomeSection(selector) {
      goToHomeSection(this, selector);
    },
  },
  computed: {
        userDetails () {
            return this.$store.state.authentication.user
        },
        isRedirectedBrokerUrl(){
          return (localStorage.getItem('utmParams')==undefined || localStorage.getItem('utmParams')==null )?false:true;
        },
        isMSIUser() {
          return (localStorage.getItem('isMSIUser')=='true' )?true:false;
        },
        isLoggedin () {
          return !!localStorage.getItem('psitoken')
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/newfooter.vue